'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp2, _class3, _temp3; /**
                                                      * Created by li on 2016/4/8.
                                                      */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftNavButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LeftNavButton, _Component);

  function LeftNavButton() {
    (0, _classCallCheck3.default)(this, LeftNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LeftNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(LeftNavButton, [{
    key: 'render',
    value: function render() {
      var page = this.props.page;

      var styles = require('./GoeasyCarousel.scss');
      if (page === 'mainCenter') {
        styles = require('./Home.scss');
      }
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.Carousel_side }));
    }
  }]);
  return LeftNavButton;
}(_react.Component), _class.propTypes = {
  page: _react.PropTypes.string
}, _temp);
var RightNavButton = (_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(RightNavButton, _Component2);

  function RightNavButton() {
    (0, _classCallCheck3.default)(this, RightNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(RightNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(RightNavButton, [{
    key: 'render',
    value: function render() {
      var page = this.props.page;

      var styles = require('./GoeasyCarousel.scss');
      if (page === 'mainCenter') {
        styles = require('./Home.scss');
      }
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.Carousel_side + ' ' + styles.Carousel_side_right }));
    }
  }]);
  return RightNavButton;
}(_react.Component), _class2.propTypes = {
  page: _react.PropTypes.string
}, _temp2);
var GoeasyCarousel = (_temp3 = _class3 = function (_Component3) {
  (0, _inherits3.default)(GoeasyCarousel, _Component3);

  function GoeasyCarousel() {
    (0, _classCallCheck3.default)(this, GoeasyCarousel);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasyCarousel).apply(this, arguments));
  }

  (0, _createClass3.default)(GoeasyCarousel, [{
    key: 'onAEleClick',
    value: function onAEleClick(url) {
      var routerUrl = this.props.routerUrl;

      if (routerUrl) {
        routerUrl(url);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var styles = require('./GoeasyCarousel.scss');
      var _props = this.props;
      var images = _props.images;
      var page = _props.page;
      var style = _props.style;
      var routerFlag = _props.routerFlag;

      var isArrow = true;
      if (page === 'mainOther' || page === 'productsListMiddle') {
        isArrow = false;
      }
      var settings = {
        dots: true,
        infinite: true,
        arrows: isArrow,
        dotsClass: 'slick-dots ' + styles.dotsClass,
        // fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
        prevArrow: page === 'mainOther' || page === 'productsListMiddle' ? '' : _react2.default.createElement(LeftNavButton, this.props),
        nextArrow: page === 'mainOther' || page === 'productsListMiddle' ? '' : _react2.default.createElement(RightNavButton, this.props)
      };
      var imgStyle = {};
      //  height: 423px;
      if (page === 'productList') {
        imgStyle.height = '423px';
      }
      var currentStyle = {};
      if (style) {
        currentStyle = (0, _extends3.default)({}, style);
        imgStyle = (0, _extends3.default)({}, style);
      }
      return _react2.default.createElement(
        _reactSlick2.default,
        (0, _extends3.default)({ className: styles.carousel }, settings, { style: (0, _extends3.default)({}, currentStyle) }),
        images.map(function (image, index) {
          var returnCom = '';
          if (page === 'mainCenter' && image.url !== '') {
            returnCom = _react2.default.createElement(
              'a',
              { key: index, href: image.url },
              _react2.default.createElement('img', { style: (0, _extends3.default)({}, imgStyle), alt: '',
                src: image.img })
            );
          } else {
            if (routerFlag === 'mainPage') {
              returnCom = image.url !== '' ? _react2.default.createElement(
                'a',
                { key: index, onClick: function onClick() {
                    return _this4.onAEleClick(image.url);
                  }, style: { cursor: 'pointer' } },
                _react2.default.createElement('img', {
                  style: (0, _extends3.default)({}, imgStyle),
                  alt: '',
                  src: image.img })
              ) : _react2.default.createElement('img', { key: index, style: (0, _extends3.default)({}, imgStyle), alt: '', src: image.img });
            } else {
              returnCom = image.url !== '' ? _react2.default.createElement(
                'a',
                { key: index, href: image.url, target: '_blank', style: { cursor: 'pointer' } },
                _react2.default.createElement('img', { style: (0, _extends3.default)({}, imgStyle),
                  alt: '',
                  src: image.img })
              ) : _react2.default.createElement('img', { key: index, style: (0, _extends3.default)({}, imgStyle), alt: '', src: image.img });
            }
            // return <a href={image.url}><img key={index} style={{...imgStyle}} alt="" src={image.img}/></a>;
          }
          return returnCom;
        })
      );
    }
  }]);
  return GoeasyCarousel;
}(_react.Component), _class3.propTypes = {
  images: _react.PropTypes.array.isRequired,
  page: _react.PropTypes.string,
  style: _react.PropTypes.object,
  routerFlag: _react.PropTypes.string,
  routerUrl: _react.PropTypes.func
}, _temp3);
exports.default = GoeasyCarousel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyCarousel/GoeasyCarousel.js
 ** module id = 1338
 ** module chunks = 0
 **/